import { createAction, props } from '@ngrx/store';
import { Supplier } from '../_models';

// Action types
export const loadSuppliers = createAction('[Supplier] Load suppliers');
export const loadSuppliersSuccess = createAction(
  '[Supplier] Load Suppliers Success',
  props<{ suppliers: Supplier[] }>()
);
export const loadSuppliersFailure = createAction(
  '[Supplier] Load Suppliers Failure',
  props<{ error: any }>()
);

export const addSupplier = createAction('[Supplier] Add Supplier', props<{ supplier: Supplier }>());
export const addSupplierSuccess = createAction(
  '[Supplier] Add Supplier Success',
  props<{ supplier: Supplier }>()
);
export const addSupplierFailure = createAction(
  '[Supplier] Add Supplier Failure',
  props<{ error: any }>()
);

export const updateSupplier = createAction(
  '[Supplier] Update Supplier',
  props<{ supplier: Supplier }>()
);
export const updateSupplierSuccess = createAction(
  '[Supplier] Update Supplier Success',
  props<{ supplier: Supplier }>()
);
export const updateSupplierFailure = createAction(
  '[Supplier] Update Supplier Failure',
  props<{ error: any }>()
);

export const deleteSupplier = createAction('[Supplier] Delete Supplier', props<{ id: number }>());
export const deleteSupplierSuccess = createAction(
  '[Supplier] Delete Supplier Success',
  props<{ id: number }>()
);
export const deleteSupplierFailure = createAction(
  '[Supplier] Delete Supplier Failure',
  props<{ error: any }>()
);
